module.exports = __webpack_public_path__ + "static/media/carousel-img2.0021e048.png";